export default __webpack_public_path__ + "static/media/Freebooter's Armguard of the Roaring Jungle.cc803a8c.jpg";